import { render, staticRenderFns } from "./Ibans.vue?vue&type=template&id=5505fb01&scoped=true"
import script from "./Ibans.vue?vue&type=script&lang=js"
export * from "./Ibans.vue?vue&type=script&lang=js"
import style0 from "./Ibans.vue?vue&type=style&index=0&id=5505fb01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505fb01",
  null
  
)

export default component.exports